import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CustomEditComponent } from './custom-edit.component';

@NgModule({
  declarations: [CustomEditComponent],
  imports: [CommonModule, MatIconModule]
})
export class CustomEditModule { }
